query getCountries {
  localization {
    availableCountries {
      currency {
        isoCode
        symbol
      }
      isoCode
      name
    }
  }
}
